import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { prepend } from 'ramda';
import { withAsyncActions } from 'react-async-client';

import { calendar } from 'constants/routes';
import UserFilter from 'components/common/controls/UserFilter';
import { getCalendarUsers } from 'actions/asyncActions';
import { getUser } from 'actions/asyncActions';

@connect((state) => ({
    user: getUser.selectData(state)
}))
@withAsyncActions({ getCalendarUsers }, { dispatchOnMount: true, autoReset: true })
export default class CalendarUserFilter extends Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        userId: PropTypes.number.isRequired,
        getCalendarUsers: PropTypes.object.isRequired,
        disabled: PropTypes.bool,
    };

    render() {
        const { userId, disabled, getCalendarUsers: { data }, user: { id, username } } = this.props;
        const userList = prepend({ id, surname: username }, data);

        return (
            <UserFilter
                userId={userId}
                namePath="surname"
                userList={userList}
                route={calendar}
                disabled={disabled}
            />
        );
    }
}
